import React from 'react';

import { MainScreen } from '@/components/organisms/MainScreen';
import { useTranslator } from '@/hooks/useTranslator';

export const Profile: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return <MainScreen title={tr('PROFILE')} />;
};
